import * as Config from 'Config';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../../../components';
import ClientDataContext from '../../../../store/client-data-context';
import {
  AuthErrorResponseCode,
  AuthErrorResponseCodeToDescriptionMap,
} from '../../../../common/types/auth-error-response';

interface BackToServiceProviderLinkProps {
  errorCode: AuthErrorResponseCode;
  errorDescription?: string;
  label?: string;
}

export const BackToServiceProviderLink = ({ label, errorCode, errorDescription }: BackToServiceProviderLinkProps) => {
  const { t } = useTranslation();
  const clientCtx = useContext(ClientDataContext);

  const cancelSession = () => {
    fetch(Config.SESSION_DATA_URL, {
      method: 'DELETE',
      credentials: 'include',
      headers: new Headers({
        'X-Trace-Id': clientCtx.traceId,
      }),
    })
      .then(() => {
        const redirectUri = new URL(clientCtx.client.redirectUri);
        redirectUri.searchParams.append('state', clientCtx.client.state);
        redirectUri.searchParams.append('error', errorCode);
        redirectUri.searchParams.append('error_description', errorDescription ?? AuthErrorResponseCodeToDescriptionMap[errorCode]);
        window.location.href = redirectUri.href;
      })
      .catch(function (err) {
        console.error('error_cancelling_session', err);
      });
  };

  return (
    <Button
      id="cancel-session"
      size="m"
      appearance="text"
      onClick={cancelSession}
      {...{ 'data-testid': 'sessionCancelLink' }}
    >
      {label ?? t('form.general.abort')}
    </Button>
  );
};
